export const SET_VALUE_KEYS = {
  fromDate: 'fromDate',
  toDate: 'toDate',
}

export const ABSENCE_REQUEST_COMMENT_ID = 'absence-request-comment'

export const UNIQUE_OWNER = 1

export const NUM_DAYS_THRESHOLD = 1

export const DAY_PICKER_MAX_YEARS = 9
